import { Box, type BoxProps, Flex } from '@chakra-ui/react'
import { useRouter } from 'next/router'

import logger from '@/utils/logger'

import CourseQ from '@/queries/CourseQ'
import { useQuery } from '@/client/context/query'
import type { SQLFragment } from '@/client/query'

import Select from '@/components/UI/Select'

export const ALL_TOPICS = 'All Topics'

// 8/26/25 (akshit): This function is pretty old and could probably be simplified, but it works so I've recently updated it with a customWhere.
export function useCourse({
  includeAllTopics,
  excludeOther = false,
  includeSATBootcamp = false,
  customWhere,
}: {
  includeAllTopics: boolean
  excludeOther?: boolean
  includeSATBootcamp?: boolean
  customWhere?: SQLFragment<boolean>
}): {
  course: string | null
  courses: (string | null)[]
} {
  const query = useQuery()
  const router = useRouter()
  const defaultCourse = includeAllTopics ? ALL_TOPICS : null
  const course = router.query.course != null ? `${router.query.course}` : defaultCourse
  const courses = query
    .many(CourseQ.getAll({ excludeOther, includeSATBootcamp, customWhere }))
    .map(entry => entry(CourseQ.name))

  if (includeAllTopics) {
    return { course, courses: ([ALL_TOPICS] as (string | null)[]).concat(courses) }
  }
  return { course, courses }
}

const CourseFinder: React.FC<{
  courses: (string | null)[]
  course: string | null
  text: string | null
  width?: BoxProps['width']
}> = ({ courses, course, text, width = '15rem' }) => {
  const router = useRouter()
  const options = courses.filter(item => item != null).map(c => ({ label: c, value: c }))
  const defaultOption = course == null ? options[0] : options.find(x => x.value === course)

  function handleSortChange(newCourse: string) {
    router
      .replace({
        query: {
          ...router.query,
          course: newCourse,
          sort: 'coursesequence',
          page: '1',
        },
      })
      .catch(err => {
        logger.error('Navigation failed', { err })
      })
  }

  return (
    <Flex align="center">
      {text == null ? null : (
        <Box fontWeight="bold" mr={2}>
          {text}
        </Box>
      )}
      <Box width={width}>
        <Select
          instanceId="course-finder"
          name="course-finder"
          options={options}
          defaultValue={defaultOption}
          onChange={e => handleSortChange(e?.value ?? '')}
          isClearable={false}
          components={{
            IndicatorSeparator: () => null,
          }}
        />
      </Box>
    </Flex>
  )
}

export default CourseFinder
